<template lang="html">
  <div id="d-policy-page">

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-12 col-title">
          <h2>Políticas y reglamentos</h2>
        </div>
      </div>
    </section>

    <section class="pages-section">
      <div class="box-white-s1">
        <router-link class="box-page-link" :to="'politicas-y-reglamentos/'+r.id" v-for="(r,indx) in rows" :key="'row'+r.id">
          <h5>{{r.name}}</h5>
        </router-link>

        
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      rows:[],
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
    getRows(){
      axios.get(tools.url("/api/politics")).then((response)=>{
          this.rows = response.data;
      }).catch(()=>{});
    }
  },
  mounted(){
      this.getRows();
  }
}
</script>

